/**
 * @param {string | undefined} [className]
 * @returns {React.ReactElement}
 */
const CompanyLogoVamed = ({ className }) => (
  <svg
    width="236"
    height="63"
    viewBox="0 0 236 63"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_70)">
      <path
        d="M29.4283 21.3818H12.421L36.1166 62.5227L59.7166 21.3818H42.8048L36.1166 32.9318L29.4283 21.3818Z"
        fill="currentColor"
      />
      <path
        d="M227.783 30.5455C232.56 30.5455 235.522 28.5409 235.522 24.4364C235.522 20.7136 233.038 19.3773 228.834 18.4227C226.254 17.7545 225.49 17.4682 225.49 16.6091C225.49 15.8455 225.968 15.2727 227.688 15.2727C229.598 15.2727 231.127 15.9409 232.656 16.9909L235.236 13.4591C233.325 11.9318 231.032 10.9773 227.879 10.9773C223.579 10.9773 220.617 13.2682 220.617 16.8C220.617 20.5227 222.91 21.7636 227.114 22.7182C229.981 23.3864 230.649 23.8636 230.649 24.7227C230.649 25.7727 229.885 26.25 227.879 26.25C226.063 26.25 223.866 25.3909 222.528 24.3409L219.948 27.8727C221.764 29.4 224.63 30.5455 227.783 30.5455Z"
        fill="currentColor"
      />
      <path
        d="M94.7822 15.5591V18.4227H101.47V22.6227H94.7822V30.2591H90.0049V11.3591H104.241V15.5591H94.7822Z"
        fill="currentColor"
      />
      <path
        d="M116.662 30.2591L113.509 23.7682H110.834V30.2591H106.057V11.3591H114.656C118.764 11.3591 121.726 13.1727 121.726 17.4682C121.726 20.3318 120.389 22.05 118.191 23.0046L121.917 30.2591H116.662ZM114.465 15.3682H110.738V19.7591H114.465C116.185 19.7591 116.949 18.9955 116.949 17.4682C116.949 16.2273 116.185 15.3682 114.465 15.3682Z"
        fill="currentColor"
      />
      <path
        d="M124.402 30.2591H138.734V26.0591H129.179V22.4318H135.198V18.2318H129.179V15.4636H138.065V11.3591H124.402V30.2591Z"
        fill="currentColor"
      />
      <path
        d="M147.524 30.5455C152.301 30.5455 155.263 28.5409 155.263 24.4364C155.263 20.7136 152.779 19.3773 148.575 18.4227C145.9 17.7545 145.231 17.4682 145.231 16.6091C145.231 15.8455 145.709 15.2727 147.428 15.2727C149.339 15.2727 150.868 15.9409 152.397 16.9909L154.977 13.4591C153.066 11.9318 150.772 10.9773 147.619 10.9773C143.32 10.9773 140.358 13.2682 140.358 16.8C140.358 20.5227 142.651 21.7636 146.855 22.7182C149.721 23.3864 150.39 23.8636 150.39 24.7227C150.39 25.7727 149.626 26.25 147.619 26.25C145.804 26.25 143.606 25.3909 142.269 24.3409L139.689 27.8727C141.504 29.4 144.371 30.5455 147.524 30.5455Z"
        fill="currentColor"
      />
      <path
        d="M157.843 30.2591H172.175V26.0591H162.62V22.4318H168.544V18.2318H162.62V15.4636H171.411V11.3591H157.843V30.2591Z"
        fill="currentColor"
      />
      <path
        d="M186.698 30.2591H190.615V11.3591H186.029V21.6682L178.768 11.3591H174.372V30.2591H179.054V19.3773L186.698 30.2591Z"
        fill="currentColor"
      />
      <path
        d="M199.024 11.3591H194.151V30.2591H199.024V11.3591Z"
        fill="currentColor"
      />
      <path
        d="M210.107 30.5455C214.884 30.5455 218.228 27.8727 218.228 22.05V11.3591H213.451V22.1455C213.451 24.7227 212.4 26.25 210.202 26.25C208.005 26.25 206.954 24.6273 206.954 22.1455V11.3591H202.081V22.1455C202.081 27.9682 205.521 30.5455 210.107 30.5455Z"
        fill="currentColor"
      />
      <path
        d="M138.447 58.8V49.1591L133.67 59.3727L128.892 49.1591V58.8H124.402V39.8046H128.892L133.861 50.4L138.638 39.8046H143.033V58.8H138.447Z"
        fill="currentColor"
      />
      <path
        d="M93.349 39.8046H88.285L94.6867 58.8H99.464L106.152 39.8046H100.993L97.1709 53.55L93.349 39.8046Z"
        fill="currentColor"
      />
      <path
        d="M146.664 58.8H160.996V54.6H151.441V50.7818H157.365V46.7727H151.441V44.0046H160.423V39.8046H146.664V58.8Z"
        fill="currentColor"
      />
      <path
        d="M117.522 58.8L116.376 55.1727H110.165L109.019 58.8H103.955L110.929 39.9H115.707L122.682 58.8H117.522ZM111.312 51.1636H115.038L113.127 45.0545L111.312 51.1636Z"
        fill="currentColor"
      />
      <path
        d="M169.5 58.8H163.48V39.9H169.882C175.615 39.9 179.532 42.2864 179.532 49.2545C179.723 56.2227 175.615 58.8 169.5 58.8ZM169.882 44.1H168.353V54.6H169.691C173.226 54.6 174.659 53.0727 174.659 49.35C174.659 45.7227 173.417 44.1 169.882 44.1Z"
        fill="currentColor"
      />
      <path
        d="M72.1377 0H22.0713L24.1733 3.81818H69.9401L72.1377 0Z"
        fill="currentColor"
      />
      <path
        d="M68.0292 7.15909H26.0842L28.2818 10.9773H65.8316L68.0292 7.15909Z"
        fill="currentColor"
      />
      <path
        d="M63.9207 14.2227H30.1927L32.4859 18.1364H61.6276L63.9207 14.2227Z"
        fill="currentColor"
      />
      <path
        d="M2.19757 3.81818H19.3004L17.0073 0H0L2.19757 3.81818Z"
        fill="currentColor"
      />
      <path
        d="M6.40164 10.9773H23.3134L21.2114 7.15909H4.10852L6.40164 10.9773Z"
        fill="currentColor"
      />
      <path
        d="M10.5101 18.1364H27.5174L25.2243 14.2227H8.31256L10.5101 18.1364Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_70">
        <rect width="236" height="63" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CompanyLogoVamed;
